import { TabsSettings } from './types';

export const tabsSettings: TabsSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        regular: {
          paddingTop: 4,
          paddingRight: 3,
          paddingBottom: 3,
          paddingLeft: 3,
        },
      },
    },
    variant: {
      prop: 'variant',
      variants: {
        primary: {
          backgroundColor: 'success.main',
        },
      },
    },
    containerVariant: {
      prop: 'containerVariant',
      variants: {
        primary: {
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: 'gray.main',
        },
      },
    },
  },
};
